/**
 * Имя ИИ-ассистента приложения — пока условно «Altera» (отличается от конкурента Luna). Единственное место,
 * где оно задано: если понадобится сменить имя, меняется только эта строка, а не десяток мест по всему webapp.
 */
export const ASSISTANT_NAME = "Altera";
